import React, { useState, useRef } from "react";

import { CheckBox, Menu, Popup } from "devextreme-react";

import { menu } from "../Visualization/data";
import ChartTypeContainer from "./ChartTypeContainer";
import SeriesContainer from "./SeriesContainer";

import { useDispatch, useSelector } from "react-redux";
import {
  updateDefaultLandscape,
  updateDefaultVertical,
} from "./Redux/axisSlice";
import {
  updateDefaultLandscape as updateDefaultLandscape2,
  updateDefaultVertical as updateDefaultVertical2,
} from "./Redux/axisTitleSlice";
import AxisTitleContainer from "./AxisTitleContainer";
import { updateChartTitleExist } from "./Redux/chartTitleSlice";
import ChartTitleContainer from "./ChartTitleContainer";
import ChartTitleAlignmentContainer from "./ChartTitleAlignmentContainer";
import {
  updateDataLabelCustomizeText,
  updateDataLabelExist,
} from "./Redux/dataLabelSlice";
import { updateArgumentAxisGrid, updateValueAxisGrid } from "./Redux/gridSlice";
import DataLabelAlignmentContainer from "./DataLabelAlignmentContainer";

export default function MenuContainer() {
  const [chartTypePopupVisible, setChartTypePopupVisible] = useState(false);
  const [seriesPopupVisible, setSeriesPopupVisible] = useState(false);
  const [axisTitlePopupVisible, setAxisTitlePopupVisible] = useState(false);
  const [axisTitleType, setAxisTitleType] = useState(null);
  const [chartTitlePopupVisible, setChartTitlePopupVisible] = useState(false);
  const [chartTitleAlignmentPopupVisible, setChartTitleAlignmentPopupVisible] =
    useState(false);
  const [dataLabelAlignmentPopupVisible, setDataLabelAlignmentPopupVisible] =
    useState(false);

  const chartTypePupupRef = useRef(null);
  const seriesPopupRef = useRef(null);
  const axisTitlePopupRef = useRef(null);
  const chartTitlePopupRef = useRef(null);
  const chartTitleAlignmentPopupRef = useRef(null);
  const dataLabelAlignmentPopupRef = useRef(null);

  const dispatch = useDispatch();

  const axis = useSelector((state) => state.axis);
  const axisTitle = useSelector((state) => state.axisTitle);
  const chartTitle = useSelector((state) => state.chartTitle);
  const dataLabel = useSelector((state) => state.dataLabel);
  const grid = useSelector((state) => state.grid);

  const onMenuItemClick = (e) => {
    if (e.itemData.id === "5") {
      setChartTypePopupVisible(true);
    } else if (e.itemData.id === "3") {
      setSeriesPopupVisible(true);
    } else if (e.itemData.id === "1_1_1") {
      dispatch(updateDefaultLandscape());
    } else if (e.itemData.id === "1_1_2") {
      dispatch(updateDefaultVertical());
    } else if (e.itemData.id === "1_2_1") {
      dispatch(updateDefaultLandscape2());

      if (!axisTitle.defaultLandscape) {
        setAxisTitleType("LANDSCAPE");
        setAxisTitlePopupVisible(true);
      }
    } else if (e.itemData.id === "1_2_2") {
      dispatch(updateDefaultVertical2());

      if (!axisTitle.defaultVertical) {
        setAxisTitleType("VERTICAL");
        setAxisTitlePopupVisible(true);
      }
    } else if (e.itemData.id === "1_3_1") {
      dispatch(updateChartTitleExist());

      if (!chartTitle.exist) {
        setChartTitlePopupVisible(true);
      }
    } else if (e.itemData.id === "1_3_2") {
      setChartTitleAlignmentPopupVisible(true);
    } else if (e.itemData.id === "1_4_1") {
      dispatch(updateDataLabelExist());
    } else if (e.itemData.id === "1_4_2") {
      setDataLabelAlignmentPopupVisible(true);
    } else if (e.itemData.id === "1_4_3") {
      dispatch(updateDataLabelCustomizeText());
    } else if (e.itemData.id === "1_7_1") {
      dispatch(updateValueAxisGrid());
    }
  };

  const onChartTypeHiding = () => {
    setChartTypePopupVisible(false);
  };

  const onSeriesHiding = () => {
    setSeriesPopupVisible(false);
  };

  const onAxisTitleHiding = () => {
    setAxisTitlePopupVisible(false);
  };

  const onChartTitleHiding = () => {
    setChartTitlePopupVisible(false);
  };

  const onChartTitleAlignmentHiding = () => {
    setChartTitleAlignmentPopupVisible(false);
  };

  const onDataLabelAlignmentHiding = () => {
    setDataLabelAlignmentPopupVisible(false);
  };

  const chartTypeContentRender = () => {
    return <ChartTypeContainer chartTypePupupRef={chartTypePupupRef} />;
  };

  const seriesContentRender = () => {
    return <SeriesContainer seriesPopupRef={seriesPopupRef} />;
  };

  const axisTitleContentRender = () => {
    return (
      <AxisTitleContainer
        axisTitleType={axisTitleType}
        axisTitlePopupRef={axisTitlePopupRef}
      />
    );
  };

  const chartTitleContentRender = () => {
    return <ChartTitleContainer chartTitlePopupRef={chartTitlePopupRef} />;
  };

  const chartTitleAlignmentContentRender = () => {
    return (
      <ChartTitleAlignmentContainer
        chartTitleAlignmentPopupRef={chartTitleAlignmentPopupRef}
      />
    );
  };

  const dataLabelAlignmentContentRender = () => {
    return (
      <DataLabelAlignmentContainer
        dataLabelAlignmentPopupRef={dataLabelAlignmentPopupRef}
      />
    );
  };

  const itemRender = (item) => {
    return (
      <div>
        {(item.id === "1_1_1" && <CheckBox value={axis.defaultLandscape} />) ||
          (item.id === "1_1_2" && <CheckBox value={axis.defaultVertical} />) ||
          (item.id === "1_2_1" && (
            <CheckBox value={axisTitle.defaultLandscape} />
          )) ||
          (item.id === "1_2_2" && (
            <CheckBox value={axisTitle.defaultVertical} />
          )) ||
          (item.id === "1_3_1" && <CheckBox value={!chartTitle.exist} />) ||
          (item.id === "1_4_1" && <CheckBox value={!dataLabel.exist} />) ||
          (item.id === "1_4_3" && dataLabel.exist && (
            <CheckBox value={dataLabel.customizeText} />
          )) ||
          (item.id === "1_7_1" && <CheckBox value={grid.valueAxisGrid} />) ||
          (item.id === "1_7_2" && <CheckBox value={grid.argumentAxisGrid} />)}
        {item.name}
      </div>
    );
  };

  return (
    <React.Fragment>
      <Menu
        dataSource={menu}
        displayExpr="name"
        showFirstSubmenuMode={{
          name: "onClick",
          delay: {
            show: 0,
            hide: 300,
          },
        }}
        hideSubmenuOnMouseLeave={false}
        itemRender={itemRender}
        onItemClick={onMenuItemClick}
      ></Menu>
      <Popup
        ref={chartTypePupupRef}
        visible={chartTypePopupVisible}
        onHiding={onChartTypeHiding}
        dragEnabled={true}
        hideOnOutsideClick={false}
        showCloseButton={true}
        showTitle={true}
        title="차트 종류 변경"
        contentRender={chartTypeContentRender}
        container=".dx-viewport"
      />
      <Popup
        ref={seriesPopupRef}
        visible={seriesPopupVisible}
        onHiding={onSeriesHiding}
        dragEnabled={true}
        hideOnOutsideClick={false}
        showCloseButton={true}
        showTitle={true}
        title="데이터 원본 선택"
        contentRender={seriesContentRender}
        container=".dx-viewport"
      />
      <Popup
        ref={axisTitlePopupRef}
        visible={axisTitlePopupVisible}
        onHiding={onAxisTitleHiding}
        dragEnabled={true}
        hideOnOutsideClick={false}
        showCloseButton={true}
        title="축 제목"
        contentRender={axisTitleContentRender}
        container=".dx-viewport"
        width={500}
        height={250}
      />
      <Popup
        ref={chartTitlePopupRef}
        visible={chartTitlePopupVisible}
        onHiding={onChartTitleHiding}
        dragEnabled={true}
        hideOnOutsideClick={false}
        showCloseButton={true}
        title="차트 제목"
        contentRender={chartTitleContentRender}
        container=".dx-viewport"
        width={500}
        height={250}
      />
      <Popup
        ref={chartTitleAlignmentPopupRef}
        visible={chartTitleAlignmentPopupVisible}
        onHiding={onChartTitleAlignmentHiding}
        dragEnabled={true}
        hideOnOutsideClick={false}
        showCloseButton={true}
        title="차트 제목 정렬"
        contentRender={chartTitleAlignmentContentRender}
        container=".dx-viewport"
      />
      <Popup
        ref={dataLabelAlignmentPopupRef}
        visible={dataLabelAlignmentPopupVisible}
        onHiding={onDataLabelAlignmentHiding}
        dragEnabled={true}
        hideOnOutsideClick={false}
        showCloseButton={true}
        title="데이터 레이블 정렬"
        contentRender={dataLabelAlignmentContentRender}
        container=".dx-viewport"
      />{" "}
    </React.Fragment>
  );
}
